<template>
  <footer class="footer-bar">
    <div class="footer-main">
      <div class="footer-left">
        <div class="footer-logo-row">
          <img src="@/assets/imgs/logow.png" alt="logo" class="footer-logo" />
          <div class="footer-company-name"><span class="footer-en">Hunan Panhe Technology Co., Ltd.</span></div>
        </div>
        <div class="footer-info">
          <div>地址：湖南省长沙市开福区 天健壹平方英里H栋22楼</div>
          <div>电话：186-0138-9130</div>
          <div>邮箱：panhe@panhekji.com</div>
        </div>
      </div>
      <div class="footer-center">
        <div class="footer-desc">
          专注于数字化社区解决方案的运营服务商<br />
          致力于推动数字化手段驱动基层治理现代化<br />
          构建政府、物业、商户、居民四端协同的高效数字社区生态
        </div>
        <div class="footer-copyright">
          Copyright © 2025 panhekeji.com 湖南磐合科技服务有限公司版权所有 | <a href="https://beian.miit.gov.cn/" target="_blank">湘ICP备2025124251号-1</a>
        </div>
      </div>
      <div class="footer-right" >
        <div class="footer-qrcode" style="display: none;">
          <div class="qrcode-img">
            <img src="@/assets/imgs/advantage3.png" alt="微信二维码" />
          </div>
          <div class="qrcode-label">微信公众号</div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
};
</script>

<style scoped lang="scss">
.footer-bar {
  background: #181e29;
  color: #fff;
  width: 100vw;
  padding: 0;
  font-size: 14px;
}
.footer-main {
  max-width: 1140px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  padding: 32px 16px 30px 16px;
  box-sizing: border-box;
}
.footer-left {
  flex: 1.2;
  min-width: 220px;
}
.footer-logo-row {
  display: flex;
  align-items: flex-start;
  margin-bottom: 16px;
  flex-direction: column;
}
.footer-logo {
  height: 40px;
  margin-right: 12px;
}
.footer-company-name {
  font-size: 18px;
  font-weight: bold;
  line-height: 2;
  .footer-en {
    font-size: 12px;
    color: #b0b3bb;
    font-weight: normal;
  }
}
.footer-info {
  margin-top: 8px;
  line-height: 2;
  color: #b0b3bb;
  text-align: left;
}
.footer-center {
  flex: 1.5;
  min-width: 200px;
  text-align: left;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 0 24px;
}
.footer-desc {
  color: #b0b3bb;
  margin-bottom: 16px;
  line-height: 1.8;
}
.footer-copyright {
  color: #b0b3bb;
  font-size: 13px;
  border-top: 1px solid #ccc;
  padding-top: 10px;
  a {
    color: #b0b3bb;
    text-decoration: underline;
  }
}
.footer-right {
  flex: 0.8;
  min-width: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}
.footer-qrcode {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.qrcode-img {
  width: 70px;
  height: 70px;
  background: #fff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
.qrcode-label {
  color: #b0b3bb;
  font-size: 13px;
}

@media (max-width: 900px) {
  .footer-main {
    flex-direction: column;
    align-items: flex-start;
    padding: 24px 8px 0 8px;
  }
  .footer-left, .footer-center, .footer-right {
    min-width: 0;
    width: 100%;
    padding: 0;
  }
  .footer-center {
    padding: 16px 0;
  }
  .footer-right {
    align-items: flex-start;
    margin-top: 16px;
  }
}
@media (max-width: 600px) {
  .footer-bar {
    font-size: 12px;
  }
  .footer-main {
    padding: 16px 2vw 0 2vw;
  }
  .footer-logo {
    height: 28px;
  }
  .qrcode-img {
    width: 54px;
    height: 54px;
  }
}
</style> 